export default "__VITE_ASSET___rIz1Xu$__"